import React from "react";
import "./footer.css";

export default function Footer() {
  return (
    <footer className="footer-container">
      SEB
    </footer>
  );
}
